import React, { Component } from 'react'
import { sanitize } from 'dompurify'

import { formatCurrency } from '@utilities/numbers'

import styles from './PropertyCardFeatured.module.scss'
import { IProperty } from '@features/properties/types'

interface IProps {
  property: IProperty | null | undefined
  loading?: boolean
  showShortDesc?: boolean
  showFixedMortgageDesc?: boolean
  showCrowdEquityDesc?: boolean
  showInvestmentSummary?: boolean
}

/**
 * PropertyCardFeatured
 * Large card to display more detailed information about the given
 * Property in the first fold of the page.
 *
 * Includes a large image to the left of the details and a long
 * snippet of text for the description with key details as bullets.
 */
export default class PropertyCardFeatured extends Component<IProps> {
  render() {
    const {
      property,
      loading,
      showShortDesc,
      showFixedMortgageDesc,
      showCrowdEquityDesc,
      showInvestmentSummary
    } = this.props
    let image: any = ''
    let description = ''

    if (property) {
      image = property.photos.find((photo) => photo.is_primary === true)
      description = property.description_short
      if (description?.length > 150) {
        description = description.slice(0, 102).trim() + '..'
      }
    }

    let loadingClass = loading ? ' -loading' : ''

    return (
      <div className={styles.card}>
        {loading || image ? (
          <div className={styles.picture}>
            <picture className={`Picture -cover${loadingClass}`}>
              {!loading ? (
                <img
                  alt="Image of property."
                  className="Image -lazy"
                  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                  data-src={image.url}
                />
              ) : null}
            </picture>
          </div>
        ) : null}

        <div className={styles.details}>
          <div className="Row -between -mod-margin-top" style={{ width: '100%' }}>
            <h3 className={`Heading -four${loadingClass}`}>
              {property && `${property.posttown}, ${property.postcode}`}
            </h3>
            <h3 className={`Heading -four${loadingClass}`}>
              {property && formatCurrency(property.valuation, 0)}
            </h3>
          </div>

          {showShortDesc ? (
            <div className={`Text -mod-margin-top${loadingClass}`}>
              {loading ? (
                <>
                  <span className="DummyLine -long" />
                  <span className="DummyLine -medium" />
                  <span className="DummyLine -short" />
                </>
              ) : (
                <p>{description}</p>
              )}
            </div>
          ) : null}

          <ul className={`List -bulleted -grey${loadingClass} -mod-margin-top`}>
            {property && showFixedMortgageDesc ? <li>`Fixed mortgage: ${property.fixed_mortgage_short_description}`</li> : null}
            {property && showCrowdEquityDesc ? <li>`Equity mortgage: ${property.equity_mortgage_short_description}`</li> : null}
          </ul>

        {property && showInvestmentSummary ? <p dangerouslySetInnerHTML={{ __html: sanitize(property.investment_summary)}} /> : null}

          {this.props.children}
        </div>
      </div>
    )
  }
}
